import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import MDEditor from "@uiw/react-md-editor";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    marginTop: "1rem"
  }
}));

const MarkdownField = ({ name, label }) => {
  const classes = useStyles();
  const [field, , { setValue }] = useField(name);

  return (
    <div className={classes.container}>
      <Typography variant="body2" paragraph>
        <strong>{label}</strong>
      </Typography>
      <MDEditor value={field.value} onChange={setValue} />
    </div>
  );
};

MarkdownField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  name: PropTypes.string.isRequired
};

export default MarkdownField;
